import { createTheme } from 'components/base';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#FBAD33',
    },
  },
  components: {
    MuiPickersSectionList: {
      styleOverrides: {
        root: {
          width: 'auto !important',
        },
      },
    },
    // MuiInputBase: {
    //   styleOverrides: {
    //     root: {
    //       fontSize: '.875rem',
    //       width: '50px !important',
    //     },
    //     input: {
    //       padding: '6px 16px',
    //       height: '42px',
    //       margin: '0 !important',
    //       // border: 'none !important',
    //       // minWidth: '80px !important',
    //     },
    //   },
    // },
    MuiIconButton: {
      styleOverrides: {
        root: {
          position: 'static',
          transform: 'none  !important',
          padding: '5px !important',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#f8a430',
            borderRadius: 10,
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#f8a430',
          },
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          zIndex: '99999 !important',
        },
      },
    },
  },
});
